import { useEffect, useState, useCallback } from "react";
import { getPetVisitRecommendations } from "../../api/petService";

export const useRecommendedVisits = (trigger, initialPage = 1, initialLimit = 10) => {
    const [recommendedVisits, setRecommendedVisits] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
                const response = await getPetVisitRecommendations(page, limit);
                setRecommendedVisits(prev => {
                if (append) {
                    return {
                    ...response,
                    data: [...(prev.data || []), ...response.data],
                    };
                }
                // 🔑 Reset pagination when not appending (fresh search or initial load)
                return {
                    ...response,
                    pagination: { ...response.pagination, page }, 
                };
                });
                return response;
            } catch (err) {
                console.error("Failed to fetch recommended visits:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = recommendedVisits.pagination.page + 1;
        if (nextPage <= recommendedVisits.pagination.totalPages) {
        await fetchData(nextPage, recommendedVisits.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, recommendedVisits.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { recommendedVisits, loading, loadMore, searchFunction, resetParent };
};